// @flow

import * as React from "react"
import Modal from "react-modal"
import {withTranslation} from "react-i18next"
import ClassNames from "classnames"

import {fuzzProducts} from "../reducers/products"
import {isProductOnBabyList} from "../reducers/baby"
import Icon from "./icon"
import type {ProductOrSet, BabyList} from "../types"

type Props = {
  t: any,
  products: $ReadOnlyArray<ProductOrSet>,
  babyList: BabyList,
  onSelect: (ProductOrSet) => void,
}

type State = {
  isModalOpen: boolean,
  q: string,
  matches: $ReadOnlyArray<any>,
  focusedIdx: number,
}

const initialState = {
  isModalOpen: false,
  q: "",
  matches: [],
  focusedIdx: 0,
}

export class FuzzyProductFinder extends React.Component<Props, State> {
  handleCloseModal: () => void
  handleOpenModal: () => void
  handleAfterOpen: () => void
  handleFuzzySearch: (SyntheticInputEvent<HTMLInputElement>) => void
  handleFocus: (number) => void
  handleResultClick: (SyntheticMouseEvent<HTMLElement>, ProductOrSet) => void
  renderItem: (any, number) => any

  state = initialState

  constructor(props: Props) {
    super(props)

    Modal.setAppElement("#app")

    this.handleCloseModal = this.handleCloseModal.bind(this)
    this.handleOpenModal = this.handleOpenModal.bind(this)
    this.handleAfterOpen = this.handleAfterOpen.bind(this)
    this.handleFuzzySearch = this.handleFuzzySearch.bind(this)
    this.handleResultClick = this.handleResultClick.bind(this)
    this.handleFocus = this.handleFocus.bind(this)
    this.renderItem = this.renderItem.bind(this)
  }

  handleOpenModal() {
    this.setState({isModalOpen: true})
  }

  handleAfterOpen() {}

  handleCloseModal() {
    this.setState({isModalOpen: false})
  }

  handleFuzzySearch(e: SyntheticInputEvent<HTMLInputElement>) {
    const {products} = this.props
    const q = e.currentTarget.value
    this.setState({
      q,
      matches: fuzzProducts(q, products),
    })
  }

  handleResultClick(e: SyntheticMouseEvent<HTMLElement>, result: ProductOrSet) {
    e.preventDefault()
    this.props.onSelect(result)
    this.setState(initialState)
  }

  handleFocus(focusedIdx: number) {
    this.setState({focusedIdx})
  }

  renderItem(result: any, idx: number) {
    const {focusedIdx} = this.state
    const {babyList} = this.props
    const product = result.obj
    const classNames = ClassNames("fuzzy-result", {
      "has-focus": idx === focusedIdx,
      "is-added": isProductOnBabyList(product, babyList),
    })
    return (
      <li key={`fzr-${idx}`} className={classNames}>
        <a
          onClick={(e) => this.handleResultClick(e, product)}
          href="#"
          onFocus={() => this.handleFocus(idx)}
          onMouseOver={() => this.handleFocus(idx)}
        >
          <div>
            {product.name} <span className="text-muted">{product.subname}</span>
          </div>
          {product.isSet ? (
            <Icon
              name={`icon-${product.isDivisible ? "set-divisible" : "set"}`}
            />
          ) : null}
          {product.isHidden ? (
            <Icon name="icon-eye-disabled" className="hidden-icon" />
          ) : null}
        </a>
      </li>
    )
  }

  renderResults() {
    const {matches} = this.state
    return <ul className="fuzzy-results">{matches.map(this.renderItem)}</ul>
  }

  render() {
    const {t} = this.props
    return (
      <div className=" d-inline-block fuzzy">
        <button onClick={this.handleOpenModal} className="btn btn-icon btn-sm">
          <Icon name="icon-search" />
        </button>
        <Modal
          className="modal-dialog modal-lg"
          isOpen={this.state.isModalOpen}
          shouldCloseOnEsc={true}
          shouldCloseOnOverlayClick={true}
          onRequestClose={this.handleCloseModal}
          onAfterOpen={this.handleAfterOpen}
          contentLabel={t("intake.products.fuzzy.title")}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                {t("intake.products.fuzzy.title")}
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label={t("intake.products.fuzzy.close")}
                onClick={this.handleCloseModal}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>

            <div className="modal-body">
              <p>{t("intake.products.fuzzy.intro")}</p>
              <div className="form-group">
                <input
                  className="form-control fuzzy-input"
                  autoFocus={true}
                  onChange={this.handleFuzzySearch}
                />
              </div>
              <h5 className="modal-title">
                {t("intake.products.fuzzy.results.title")}
              </h5>
              {this.renderResults()}
            </div>
          </div>
        </Modal>
      </div>
    )
  }
}

export default withTranslation()(FuzzyProductFinder)
